// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { akEditorGutterPaddingDynamic } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var syncBlockStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-sync-block': {
      cursor: 'pointer',
      /* Danger when top level node */
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&.danger': {
        boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: "var(--ds-background-danger, #FFECEB)".concat(" !important"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
          color: "var(--ds-icon-danger, #C9372C)".concat(" !important")
        }
      },
      // borderRadius: token('radius.small', '3px'),
      marginTop: "var(--ds-space-150, 12px)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
      marginRight: "-".concat(akEditorGutterPaddingDynamic(), "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
      marginLeft: "-".concat(akEditorGutterPaddingDynamic(), "px"),
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
      paddingRight: "".concat(akEditorGutterPaddingDynamic() - 32, "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
      paddingLeft: "".concat(akEditorGutterPaddingDynamic() - 32, "px"),
      color: 'inherit',
      '&:hover': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        boxShadow: "0px 0px 0px 1px ".concat("var(--ds-background-accent-purple-subtle, #9F8FEF)")
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.ak-editor-sync-block__editor': {
        cursor: 'text'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.ak-editor-sync-block__renderer': {
        padding: '0 32px'
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '.ak-editor-sync-block.ak-editor-selected-node:not(.danger)': {
    boxShadow: "0 0 0 1px ".concat("var(--ds-background-accent-purple-bolder, #6E5DC6)"),
    borderColor: 'transparent'
  }
});